// ─────────────────────────────────────────────
// IMPORTS
// ─────────────────────────────────────────────
// import { Brand, Photo } from 'types/common'; //BRANDS DESATIVADO
import { createListCollection } from "@chakra-ui/react";
import { Photo } from "types/common";
//icons

import {
  BadgeCheck,
  BadgeDollarSign,
  CircleUser,
  Gift,
  Globe,
  Home,
  Info,
  LogOut,
  Mail,
  Megaphone,
  Phone,
  ShieldCheck,
  User,
} from "lucide-react";
// ─────────────────────────────────────────────
// SELECT INPUT DATA
// ─────────────────────────────────────────────
export const maritalStatus = createListCollection({
  items: [
    { label: "Solteiro(a)", value: "single" },
    { label: "Casado(a)", value: "married" },
    { label: "Divorciado(a)", value: "divorced" },
    { label: "Viúvo(a)", value: "widowed" },
    { label: "União estável", value: "stable-union" },
  ],
});

export const ContactReason = createListCollection({
  items: [
    { label: "Atendimento ao Público", value: "public" },
    { label: "Dúvidas, Críticas e Sugestões", value: "feedback" },
    { label: "Como se Associar", value: "associate" },
    { label: "Trabalhe Conosco", value: "work" },
  ],
});

export const RegionalItems = createListCollection({
  items: [
    { label: "ARAÇATUBA", value: 10 },
    { label: "BAURU", value: 20 },
    { label: "BRASÍLIA DISTRITO FEDERAL", value: 30 },
    { label: "CAMPINAS", value: 40 },
    { label: "CAPITAL", value: 50 },
    { label: "FRANCA", value: 60 },
    { label: "GRANDE SÃO PAULO (I, II, e III)", value: 70 },
    { label: "PIRACICABA", value: 80 },
    { label: "PRESIDENTE PRUDENTE", value: 90 },
    { label: "RIBEIRÃO PRETO", value: 100 },
    { label: "SANTOS", value: 110 },
    { label: "SÃO JOSÉ DO RIO PRETO", value: 120 },
    { label: "SOROCABA", value: 130 },
    { label: "TAUBATÉ", value: 140 },
    { label: "VALE DO RIBEIRA", value: 150 },
  ],
});

// ─────────────────────────────────────────────
// INFO CARDS (Homepage / Seções principais)
// ─────────────────────────────────────────────
//////////DESATIVADO/////////
// export const infoCardsData = [
//   {
//     title: "Nossa História",
//     description: "Clique para conhecer um pouco mais sobre a AMUFRJ, a nossa história e nossa proposta.",
//     image: `/images/common/links-image.svg`,
//     link: "/institucional/sobre",
//   },
//   {
//     title: "Links úteis",
//     description: "Acesse nossa lista de sites selecionados especialmente para você, tudo sempre à mão.",
//     image: `/images/common/links-image.svg`,
//     link: "/institucional/links-uteis",
//   },
//   {
//     title: "Diretoria e conselho",
//     description: "Saiba quem são as pessoas que compõem a nossa diretoria e estão na sua representação.",
//     image: `/images/common/links-image.svg`,
//     link: "/institucional/diretoria",
//   },
//   {
//     title: "Clube de Benefícios",
//     description: "Firmamos diversos convênios e parcerias com instituições para nossos associados.",
//     image: `/images/common/links-image.svg`,
//     link: "https://clube.aajump.com.br/",
//   },
// ];

// ─────────────────────────────────────────────
// NAVEGAÇÃO / MENUS
// ─────────────────────────────────────────────
export const navItemsData = [
  { label: "Minha conta", icon: Home, href: "/minha-conta" },
  { label: "Detalhes", icon: Info, href: "/detalhes" },
  { label: "Sair", icon: LogOut, href: "/sair" },
];

export const menuItemsData = [
  { label: "Notícias", icon: Megaphone, href: "/noticias" },
  {
    label: "Clube de Benefícios",
    icon: Gift,
    href: "https://clube.aajump.com.br/",
  },
  { label: "Classificados", icon: BadgeDollarSign, href: "/classificados" },
  {
    label: "Consultar Associado",
    icon: BadgeCheck,
    href: "/consultar-associado",
  },
  { label: "Contato", icon: User, href: "/institucional/contato" },
];

export const linksFooterData = [
  { label: "Notícias", href: "/noticias" },
  { label: "Associe-se", href: "/conta/cadastro" },
  { label: "Links úteis", href: "/institucional/links-uteis" },
  { label: "Fale conosco", href: "/institucional/contato" },
  { label: "Classificados", href: "/classificados" },
  { label: "Clube de benefícios", href: "https://clube.aajump.com.br/" },
  { label: "Diretoria e Conselho", href: "/institucional/diretoria" },
  { label: "Consulta associado", href: "/consultar-associado" },
  { label: "Política de Privacidade", href: "/institucional/politicas-de-privacidade" },
  { label: "Sobre a AAJUMP", href: "/institucional/sobre" },
  { label: "Webmail", href: "https://webmail-seguro.com.br/" },
];

// ─────────────────────────────────────────────
// INSTITUCIONAL (Navbar LEFTSIDE)
// ─────────────────────────────────────────────
export const institucionalItemsData = [
  { label: "Sobre a AAJUMP", href: "/institucional/sobre" },
  { label: "Diretoria e conselho", href: "/institucional/diretoria" },
  { label: "Links úteis", href: "/institucional/links-uteis" },
  { label: "Contato", href: "/institucional/contato" },
];

export const institucionalItemsDesktopData = [
  {
    label: "Sobre a AAJUMP",
    href: "/institucional/sobre",
    description: "Conheça nossa história",
  },
  {
    label: "Diretoria e conselho",
    href: "/institucional/diretoria",
    description: "Liderança atual",
  },
  {
    label: "Links úteis",
    href: "/institucional/links-uteis",
    description: "Recursos e informações importantes online",
  },
];
// (Mobile Navbar RIGHTSIDE)
export const menuItemsMobileData = {
  menuPermutasMobileData: [
    { label: "Banco de Permutas", href: "/conta/menu/banco-de-permutas" },
  ],
  menuClassificadosMobileData: [
    {
      label: "Meus Classificados",
      href: "/classificados?view=meus-classificados",
    },
  ],
  menuDocumentosMobileData: [
    { label: "Documentos Internos", href: "/conta/menu/documentos-internos" },
    {
      label: "Pleitos AAJUMP",
      href: "/conta/menu/documentos-internos?categoria=requerimentos",
    },
  ],
  menuPecasMobileData: [{ label: "Peças", href: "/conta/menu/banco-de-pecas" }],
  menuMinhaContaMobileData: [
    { label: "Detalhes", href: "/conta/menu/minha-conta" },
  ],
};

// ─────────────────────────────────────────────
// INSTITUCIONAL/DIRETORIA (Navbar)
// ─────────────────────────────────────────────
export const diretoriaMembers = [
  { nome: "Maicon Robson Zambrini", cargo: "Presidente" },
  { nome: "Marcos Alexandre Tavares Alves", cargo: "Secretário-Geral" },
  { nome: "Ana Sofia da Fonseca Pereira", cargo: "Tesoureira" },
  {
    nome: "Sergio Henrique Goulart Calux",
    cargo: "Diretor de Comunicação e Assessoria de Imprensa",
  },
  { nome: "Romeu Lara Júnior", cargo: "Diretor de Assuntos Estratégicos" },
  { nome: "Adolfo Carvalho Franco Filho", cargo: "Diretor de Convênio" },
];

export const conselhoFiscalMembers = [
  { nome: "Márcio Massato Inasawa Yanaguimoto" },
  { nome: "Eduardo Pollis de Faria Neves" },
  { nome: "Luciane Modelli de Andrade Sperandio" },
];

export const coordenadoresRegionais = [
  { nome: "José Sidney Decari Trevisan", cargo: "Regional de Ribeirão Preto" },
  { nome: "Rafael Malite Iunes Paschoalato", cargo: "Regional de Franca" },
  {
    nome: "Luís Felipe Velloso de Almeida Barbosa",
    cargo: "Regional de Taubaté",
  },
  { nome: "Larissa Carvalho Libadi", cargo: "Regional de Sorocaba" },
  { nome: "Maria Augusta dos Santos", cargo: "Regional do Vale do Ribeira" },
  { nome: "Guilherme Gabas de Souza", cargo: "Regional de Piracicaba" },
  {
    nome: "Sylvio Antônio de Magalhães Nunes",
    cargo: "Regional de Piracicaba",
  },
  { nome: "Naiana Martini Pereira", cargo: "Regional de Bauru" },
  {
    nome: "Ana Carolina de Souza Mendes",
    cargo: "Regional de Presidente Prudente",
  },
  { nome: "Debora Barbiero Lasca", cargo: "Regional de Campinas" },
  { nome: "Fernando José Ferreira da Silva", cargo: "Regional de Campinas" },
  {
    nome: "Thais Karina Sicoli Romano Calil",
    cargo: "Regional de São José do Rio Preto",
  },
];
// ─────────────────────────────────────────────
// LINKS ÚTEIS (/links-uteis))
// ─────────────────────────────────────────────
export const linksUteisData = [
  {
    name: "Ministério Público do Estado de São Paulo",
    url: "https://www.mpsp.mp.br",
    image: `/images/logos/MPSP-Logo.webp`,
  },
  {
    name: "Supremo Tribunal Federal",
    url: "https://www.stf.jus.br",
    image: `/images/logos/STF-Logo.webp`,
  },
  {
    name: "Tribunal de Justiça do Estado de São Paulo",
    url: "https://www.tjsp.jus.br",
    image: `/images/logos/TJSP-Logo.webp`,
  },
  {
    name: "Superior Tribunal de Justiça",
    url: "https://www.stj.jus.br",
    image: `/images/logos/STJ-Logo.webp`,
  },
];

// ─────────────────────────────────────────────
// TEXTO SOBRE A ASSOCIAÇÃO (/sobre)
// ─────────────────────────────────────────────
export const textsAboutUsData = {
  introducao: `Fundada em 18 de abril de 2015 pelos Analistas Jurídicos Marco Antonio Vicente Coelho, Vinícius Mendes, 
    Maurício Maraldi, Marcos Alexandre Tavares Alves, Flávio Marcelo Santos Lira, Carolina Mantovani Monteiro 
    e Elisa Franco Feitosa, a AAJUMP foi constituída com a finalidade de representar a carreira
    dos Analistas Jurídicos perante a direção do Ministério Público e demais autoridades públicas do Estado,
    tendo se tornado, logo no primeiro mês de existência, a maior entidade representativa da carreira.`,

  missao: `A AAJUMP, com base territorial em todo o Estado de São Paulo, tem por finalidade estatutária defender os
    direitos e interesses da categoria profissional dos seus associados, e prestar-lhes assistência, bem como
    aos seus dependentes e familiares, direta ou indiretamente, assim como qualquer ato que afete a sociedade
    e o patrimônio público.`,

  beneficios: `Por meio da realização de convênios com operadoras de planos de saúde, seguradoras, instituições de ensino,
    restaurantes, hotéis, entre outros, a AAJUMP busca proporcionar aos seus associados inúmeros benefícios,
    individuais e coletivos.`,

  valorizacao1: `Desde a histórica Assembleia de fundação, o principal objetivo da AAJUMP tem sido a busca pela valorização
    da carreira dos Analistas Jurídicos, sendo a voz dos seus representados perante a Instituição, através de
    uma dialética constante com a gestão ministerial.`,

  valorizacao2: `O princípio relacional adotado pela associação é a via diplomática, acreditando ser possível a união de
    esforços políticos entre a entidade de classe e a cúpula da Instituição para a persecução dos seus
    objetivos e interesses.`,

  valorizacao3: `Ciente da responsabilidade que carrega, a AAJUMP busca a valorização da carreira dos Analistas Jurídicos
    e o desenvolvimento das atividades exercidas por seus integrantes. O objetivo é aperfeiçoar a estrutura
    organizacional dos órgãos de execução da atividade-fim do Ministério Público, de maneira a reforçar o
    princípio democrático no serviço público estatal.`,

  valorizacao4: `A ideia é garantir que os responsáveis pela atividade fiscalizadora dos Poderes do Estado sejam altamente
    qualificados e plenamente equipados para o exercício de suas funções Institucionais. Com isso, pretende-se
    prestigiar não só os integrantes da associação, mas também o próprio Ministério Público e, principalmente,
    toda a sociedade paulista.`,
};

export const imagensHistoriaData = [
  { img: `/images/common/sobre-img-1.jpg`, alt: "Sala 1" },
  { img: `/images/common/sobre-img-2.jpg`, alt: "Sala 2" },
  { img: `/images/common/sobre-img-3.jpg`, alt: "Sala 3" },
  { img: `/images/common/sobre-img-4.jpg`, alt: "Sala 4" },
];

// ─────────────────────────────────────────────
// MARCAS/NOSSOS PARCEIROS(Home)
// ─────────────────────────────────────────────
//DESATIVADO
// export const brandsData: Brand[] = [
//   { id: 1, src: `/images/pumaLogo.svg`, alt: 'Nike' },
//   { id: 2, src: `/images/pumaLogo.svg`, alt: 'Nike' },
//   { id: 3, src: `/images/pumaLogo.svg`, alt: 'Nike' },
//   { id: 4, src: `/images/pumaLogo.svg`, alt: 'Nike' },
//   { id: 5, src: `/images/pumaLogo.svg`, alt: 'Nike' },
//   { id: 6, src: `/images/pumaLogo.svg`, alt: 'Nike' },
// ];

// ─────────────────────────────────────────────
// FOTOS DO INSTAGRAM (Home)
// ─────────────────────────────────────────────
export const instagramPhotosData: Photo[] = [
  { id: 1, src: `/mock/images/ig-post-1.jpg`, alt: "ig-post-1" },
  { id: 2, src: `/mock/images/ig-post-2.jpg`, alt: "ig-post-2" },
  { id: 3, src: `/mock/images/ig-post-3.jpg`, alt: "ig-post-3" },
  { id: 4, src: `/mock/images/ig-post-4.jpg`, alt: "ig-post-4" },
  { id: 5, src: `/mock/images/ig-post-5.jpg`, alt: "ig-post-5" },
  { id: 6, src: `/mock/images/ig-post-6.jpg`, alt: "ig-post-6" },
  { id: 7, src: `/mock/images/ig-post-7.jpg`, alt: "ig-post-7" },
  { id: 8, src: `/mock/images/ig-post-8.jpg`, alt: "ig-post-8" },
  { id: 9, src: `/mock/images/ig-post-9.jpg`, alt: "ig-post-9" },
  { id: 10, src: `/mock/images/ig-post-10.jpg`, alt: "ig-post-10" },
];

// ─────────────────────────────────────────────
// ESTATÍSTICAS (Home) DESATIVADO
// ─────────────────────────────────────────────
// export const statsData = [
//   { value: "15000", label: "usuários pelo mundo" },
//   { value: "+200", label: "instituições parceiras" },
//   { value: "+120", label: "Benefícios exclusivos" },
//   { value: "35M+", label: "Impressões" },
// ];

// ─────────────────────────────────────────────
// CONTATO (/Sobre)
// ─────────────────────────────────────────────
export const contactLinksData = [
  {
    label: "Email",
    icon: Mail,
    href: "mailto:contato@aajump.com.br",
    text: "contato@aajump.com.br",
  },
  {
    label: "Site",
    icon: Globe,
    href: "https://www.aajump.com.br",
    text: "www.aajump.com.br",
  },
  // {
  //   label: "Telefone",
  //   icon: Phone,
  //   href: null,
  //   text: "(11) 3104-1312",
  // },
  {
    label: "Facebook",
    icon: CircleUser,
    href: "https://facebook.com/aajump",
    text: "facebook.com/aajump",
  },
];

// ─────────────────────────────────────────────
//  MINHA CONTA (/minha-conta)
// ─────────────────────────────────────────────

export const MyAccNavItemsData = [
  {
    label: "Minha conta",
    href: "minha-conta",
    icon: Home,
  },
  {
    label: "Detalhes",
    href: "detalhes",
    icon: Info,
  },
  {
    label: "Segurança",
    href: "seguranca",
    icon: ShieldCheck,
  },
  {
    label: "Sair",
    href: "sair",
    icon: LogOut,
  },
];

export const maritalStatusMap: Record<string, string> = {
  single: "Solteiro(a)",
  married: "Casado(a)",
  divorced: "Divorciado(a)",
  widowed: "Viúvo(a)",
  "stable-union": "União estável",
};

export const maritalStatusMaps: Record<string, string> = {
  single: "Solteiro(a)",
  married: "Casado(a)",
  divorced: "Divorciado(a)",
  widowed: "Viúvo(a)",
  "stable-union": "União estável",
};

export const maritalStatusOptions = [
  { value: "single", label: "Solteiro(a)" },
  { value: "married", label: "Casado(a)" },
  { value: "divorced", label: "Divorciado(a)" },
  { value: "widowed", label: "Viúvo(a)" },
  { value: "stable-union", label: "União estável" },
];

export const regionalOption = [
  { value: 10, label: "ARAÇATUBA" },
  { value: 20, label: "BAURU" },
  { value: 30, label: "BRASÍLIA DISTRITO FEDERAL" },
  { value: 40, label: "CAMPINAS" },
  { value: 50, label: "CAPITAL" },
  { value: 60, label: "FRANCA" },
  { value: 70, label: "GRANDE SÃO PAULO (I, II, e III)" },
  { value: 80, label: "PIRACICABA" },
  { value: 90, label: "PRESIDENTE PRUDENTE" },
  { value: 100, label: "RIBEIRÃO PRETO" },
  { value: 110, label: "SANTOS" },
  { value: 120, label: "SÃO JOSÉ DO RIO PRETO" },
  { value: 130, label: "SOROCABA" },
  { value: 140, label: "TAUBATÉ" },
  { value: 150, label: "VALE DO RIBEIRA" },
];

// Estados do Brasil
export const stateOptions = [
  { value: "AC", label: "Acre" },
  { value: "AL", label: "Alagoas" },
  { value: "AP", label: "Amapá" },
  { value: "AM", label: "Amazonas" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "DF", label: "Distrito Federal" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MA", label: "Maranhão" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PA", label: "Pará" },
  { value: "PB", label: "Paraíba" },
  { value: "PR", label: "Paraná" },
  { value: "PE", label: "Pernambuco" },
  { value: "PI", label: "Piauí" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RN", label: "Rio Grande do Norte" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "RO", label: "Rondônia" },
  { value: "RR", label: "Roraima" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
  { value: "SE", label: "Sergipe" },
  { value: "TO", label: "Tocantins" },
];

// ─────────────────────────────────────────────
//  BANCO DE PERMUTAS (/conta/menu/banco-de-permutas)
// ─────────────────────────────────────────────
export const regionalOptionsValues = [
  { value: 10, label: "Araçatuba" },
  { value: 20, label: "Bauru" },
  { value: 30, label: "Brasília Distrito Federal" },
  { value: 40, label: "Campinas" },
  { value: 50, label: "Capital" },
  { value: 60, label: "Franca" },
  { value: 70, label: "Marília" },
  { value: 80, label: "Piracicaba" },
  { value: 90, label: "Presidente Prudente" },
  { value: 100, label: "Ribeirão Preto" },
  { value: 110, label: "Santos" },
  { value: 120, label: "São José Do Rio Preto" },
  { value: 130, label: "São José Dos Campos" },
  { value: 140, label: "Sorocaba" },
  { value: 150, label: "Vale Do Ribeira" },
];

export const regionalOptionsWithValues = [
  { value: 10, label: "ARAÇATUBA" },
  { value: 20, label: "BAURU" },
  { value: 40, label: "CAMPINAS" },
  { value: 30, label: "BRASÍLIA DISTRITO FEDERAL" },
  { value: 50, label: "CAPITAL - ENTRÂNCIA FINAL" },
  { value: 60, label: "FRANCA" },
  { value: 70, label: "GRANDE SÃO PAULO" },
  { value: 80, label: "PIRACICABA" },
  { value: 90, label: "PRESIDENTE PRUDENTE" },
  { value: 100, label: "RIBEIRÃO PRETO" },
  { value: 110, label: "SANTOS" },
  { value: 120, label: "SÃO JOSÉ DO RIO PRETO" },
  { value: 130, label: "SOROCABA" },
  { value: 140, label: "TAUBATÉ" },
  { value: 150, label: "VALE DO RIBEIRA" },
];

export const regionalOptions = [
  {
    label: "Vale do Ribeira",
    options: [
      { value: "Cananeia", label: "Cananeia" },
      { value: "Eldorado", label: "Eldorado" },
      { value: "Iguape", label: "Iguape" },
      { value: "Itariri", label: "Itariri" },
      { value: "Jacupiranga", label: "Jacupiranga" },
      { value: "Juquiá", label: "Juquiá" },
      { value: "Miracatu", label: "Miracatu" },
      { value: "Pariquera-Açu", label: "Pariquera-Açu" },
      { value: "Registro", label: "Registro" },
    ],
  },
  {
    label: "Taubaté",
    options: [
      { value: "Aparecida", label: "Aparecida" },
      { value: "Bananal", label: "Bananal" },
      { value: "Caçapava", label: "Caçapava" },
      { value: "Cachoeira Paulista", label: "Cachoeira Paulista" },
      { value: "Campos de Jordão", label: "Campos de Jordão" },
      { value: "Caraguatatuba", label: "Caraguatatuba" },
      { value: "Cruzeiro", label: "Cruzeiro" },
      { value: "Cunha", label: "Cunha" },
      { value: "Guaratinguetá", label: "Guaratinguetá" },
      { value: "Ilhabela", label: "Ilhabela" },
      { value: "Jacareí", label: "Jacareí" },
      { value: "Lorena", label: "Lorena" },
      { value: "Paraibuna", label: "Paraibuna" },
      { value: "Pindamonhangaba", label: "Pindamonhangaba" },
      { value: "Piquete", label: "Piquete" },
      { value: "Potim", label: "Potim" },
      { value: "Queluz", label: "Queluz" },
      { value: "Roseira", label: "Roseira" },
      { value: "Salesópolis", label: "Salesópolis" },
      { value: "Santa Branca", label: "Santa Branca" },
      { value: "São Bento do Sapucaí", label: "São Bento do Sapucaí" },
      { value: "São José dos Campos", label: "São José dos Campos" },
      { value: "São Luiz do Paraitinga", label: "São Luiz do Paraitinga" },
      { value: "São Sebastião", label: "São Sebastião" },
      { value: "Taubaté", label: "Taubaté" },
      { value: "Tremembé", label: "Tremembé" },
      { value: "Ubatuba", label: "Ubatuba" },
    ],
  },
  {
    label: "Sorocaba",
    options: [
      { value: "Angatuba", label: "Angatuba" },
      { value: "Apiaí", label: "Apiaí" },
      { value: "Boituva", label: "Boituva" },
      { value: "Buri", label: "Buri" },
      { value: "Cabreúva", label: "Cabreúva" },
      { value: "Capão Bonito", label: "Capão Bonito" },
      { value: "Capela do Alto", label: "Capela do Alto" },
      { value: "Cesário Lange", label: "Cesário Lange" },
      { value: "Guareí", label: "Guareí" },
      { value: "Ibiúna", label: "Ibiúna" },
      { value: "Iperó", label: "Iperó" },
      { value: "Itaberá", label: "Itaberá" },
      { value: "Itaí", label: "Itaí" },
      { value: "Itapetininga", label: "Itapetininga" },
      { value: "Itapeva", label: "Itapeva" },
      { value: "Itaporanga", label: "Itaporanga" },
      { value: "Itararé", label: "Itararé" },
      { value: "Itu", label: "Itu" },
      { value: "Mairinque", label: "Mairinque" },
      { value: "Paranapanema", label: "Paranapanema" },
      { value: "Piedade", label: "Piedade" },
      { value: "Pilar do Sul", label: "Pilar do Sul" },
      { value: "Porangaba", label: "Porangaba" },
      { value: "Porto Feliz", label: "Porto Feliz" },
      { value: "Salto", label: "Salto" },
      { value: "Salto de Pirapora", label: "Salto de Pirapora" },
      { value: "São Miguel Arcanjo", label: "São Miguel Arcanjo" },
      { value: "São Roque", label: "São Roque" },
      { value: "Sorocaba", label: "Sorocaba" },
      { value: "Taquarituba", label: "Taquarituba" },
      { value: "Tatuí", label: "Tatuí" },
      { value: "Tietê", label: "Tietê" },
      { value: "Votorantim", label: "Votorantim" },
    ],
  },
  {
    label: "São José do Rio Preto",
    options: [
      { value: "Auriflama", label: "Auriflama" },
      { value: "Barretos", label: "Barretos" },
      { value: "Cardoso", label: "Cardoso" },
      { value: "Catanduva", label: "Catanduva" },
      { value: "Colina", label: "Colina" },
      { value: "Estrela d'Oeste", label: "Estrela d'Oeste" },
      { value: "Fernandópolis", label: "Fernandópolis" },
      { value: "General Salgado", label: "General Salgado" },
      { value: "Icém", label: "Icém" },
      { value: "Itajobi", label: "Itajobi" },
      { value: "Jales", label: "Jales" },
      { value: "José Bonifácio", label: "José Bonifácio" },
      { value: "Macaubal", label: "Macaubal" },
      { value: "Mirassol", label: "Mirassol" },
      { value: "Monte Aprazível", label: "Monte Aprazível" },
      { value: "Neves Paulista", label: "Neves Paulista" },
      { value: "Nhandeara", label: "Nhandeara" },
      { value: "Nova Granada", label: "Nova Granada" },
      { value: "Novo Horizonte", label: "Novo Horizonte" },
      { value: "Olímpia", label: "Olímpia" },
      { value: "Ouroeste", label: "Ouroeste" },
      { value: "Palestina", label: "Palestina" },
      { value: "Palmeira d'Oeste", label: "Palmeira d'Oeste" },
      { value: "Paulo de Faria", label: "Paulo de Faria" },
      { value: "Potirendaba", label: "Potirendaba" },
      { value: "Riolândia", label: "Riolândia" },
      { value: "Santa Adélia", label: "Santa Adélia" },
      { value: "Santa Fé do Sul", label: "Santa Fé do Sul" },
      { value: "São José do Rio Preto", label: "São José do Rio Preto" },
      { value: "Tabapuã", label: "Tabapuã" },
      { value: "Tanabi", label: "Tanabi" },
      { value: "Urânia", label: "Urânia" },
      { value: "Urupês", label: "Urupês" },
      { value: "Votuporanga", label: "Votuporanga" },
    ],
  },
  {
    label: "Santos",
    options: [
      { value: "Bertioga", label: "Bertioga" },
      { value: "Cubatão", label: "Cubatão" },
      { value: "Guarujá", label: "Guarujá" },
      { value: "Itanhaém", label: "Itanhaém" },
      { value: "Mongaguá", label: "Mongaguá" },
      { value: "Peruíbe", label: "Peruíbe" },
      { value: "Praia Grande", label: "Praia Grande" },
      { value: "Santos", label: "Santos" },
      { value: "São Vicente", label: "São Vicente" },
    ],
  },
  {
    label: "Ribeirão Preto",
    options: [
      { value: "Américo Brasiliense", label: "Américo Brasiliense" },
      { value: "Araraquara", label: "Araraquara" },
      { value: "Bebedouro", label: "Bebedouro" },
      { value: "Brodowski", label: "Brodowski" },
      { value: "Caconde", label: "Caconde" },
      { value: "Cajuru", label: "Cajuru" },
      { value: "Casa Branca", label: "Casa Branca" },
      { value: "Cravinhos", label: "Cravinhos" },
      { value: "Descalvado", label: "Descalvado" },
      { value: "Guariba", label: "Guariba" },
      { value: "Ibaté", label: "Ibaté" },
      { value: "Jaboticabal", label: "Jaboticabal" },
      { value: "Jardinópolis", label: "Jardinópolis" },
      { value: "Matão", label: "Matão" },
      { value: "Mococa", label: "Mococa" },
      { value: "Monte Alto", label: "Monte Alto" },
      { value: "Monte Azul Paulista", label: "Monte Azul Paulista" },
      { value: "Pirangi", label: "Pirangi" },
      { value: "Pirassununga", label: "Pirassununga" },
      { value: "Pitangueiras", label: "Pitangueiras" },
      { value: "Pontal", label: "Pontal" },
      { value: "Porto Ferreira", label: "Porto Ferreira" },
      { value: "Ribeirão Bonito", label: "Ribeirão Bonito" },
      { value: "Ribeirão Preto", label: "Ribeirão Preto" },
      { value: "Santa Cruz da Palmeiras", label: "Santa Cruz da Palmeiras" },
      { value: "Santa Rita do Passa 4", label: "Santa Rita do Passa 4" },
      { value: "Santa Rosa do Viterbo", label: "Santa Rosa do Viterbo" },
      { value: "São Carlos", label: "São Carlos" },
      { value: "São José do Rio Pardo", label: "São José do Rio Pardo" },
      { value: "São Sebastião da Grama", label: "São Sebastião da Grama" },
      { value: "São Simão", label: "São Simão" },
      { value: "Serra Azul", label: "Serra Azul" },
      { value: "Serrana", label: "Serrana" },
      { value: "Sertãozinho", label: "Sertãozinho" },
      { value: "Taiúva", label: "Taiúva" },
      { value: "Tambaú", label: "Tambaú" },
      { value: "Taquaritinga", label: "Taquaritinga" },
      { value: "Viradouro", label: "Viradouro" },
    ],
  },
  {
    label: "Presidente Prudente",
    options: [
      { value: "Adamantina", label: "Adamantina" },
      { value: "Assis", label: "Assis" },
      { value: "Bastos", label: "Bastos" },
      { value: "Caiuá", label: "Caiuá" },
      { value: "Candido Mota", label: "Candido Mota" },
      { value: "Dracena", label: "Dracena" },
      { value: "Flórida Paulista", label: "Flórida Paulista" },
      { value: "Florínia", label: "Florínia" },
      { value: "Herculândia", label: "Herculândia" },
      { value: "Iepê", label: "Iepê" },
      { value: "Irapuru", label: "Irapuru" },
      { value: "Junqueirópolis", label: "Junqueirópolis" },
      { value: "Lucélia", label: "Lucélia" },
      { value: "Marabá Paulista", label: "Marabá Paulista" },
      { value: "Maracaí", label: "Maracaí" },
      { value: "Martinópolis", label: "Martinópolis" },
      { value: "Mirante do Paranapanema", label: "Mirante do Paranapanema" },
      { value: "Osvaldo Cruz", label: "Osvaldo Cruz" },
      { value: "Pacaembu", label: "Pacaembu" },
      { value: "Panorama", label: "Panorama" },
      { value: "Paraguaçu Paulista", label: "Paraguaçu Paulista" },
      { value: "Pirapozinho", label: "Pirapozinho" },
      { value: "Pracinha", label: "Pracinha" },
      { value: "Presidente Bernardes", label: "Presidente Bernardes" },
      { value: "Presidente Epitácio", label: "Presidente Epitácio" },
      { value: "Presidente Prudente", label: "Presidente Prudente" },
      { value: "Presidente Venceslau", label: "Presidente Venceslau" },
      { value: "Quatá", label: "Quatá" },
      { value: "Rancharia", label: "Rancharia" },
      { value: "Regente Feijó", label: "Regente Feijó" },
      { value: "Rinópolis", label: "Rinópolis" },
      { value: "Rosana", label: "Rosana" },
      { value: "Santo Anastácio", label: "Santo Anastácio" },
      { value: "Teodoro Sampaio", label: "Teodoro Sampaio" },
      { value: "Tupã", label: "Tupã" },
      { value: "Tupi Paulista", label: "Tupi Paulista" },
    ],
  },
  {
    label: "Piracicaba",
    options: [
      { value: "Americana", label: "Americana" },
      { value: "Araras", label: "Araras" },
      { value: "Brotas", label: "Brotas" },
      { value: "Capivari", label: "Capivari" },
      { value: "Cerquilho", label: "Cerquilho" },
      { value: "Conchas", label: "Conchas" },
      { value: "Cordeirópolis", label: "Cordeirópolis" },
      { value: "Itirapina", label: "Itirapina" },
      { value: "Laranjal Paulista", label: "Laranjal Paulista" },
      { value: "Leme", label: "Leme" },
      { value: "Limeira", label: "Limeira" },
      { value: "Piracicaba", label: "Piracicaba" },
      { value: "Rio Claro", label: "Rio Claro" },
      { value: "Rio das Pedras", label: "Rio das Pedras" },
      { value: "Santa Bárbara d'Oeste", label: "Santa Bárbara d'Oeste" },
      { value: "São Pedro", label: "São Pedro" },
    ],
  },
  {
    label: "Grande São Paulo",
    options: [
      { value: "Arujá", label: "Arujá" },
      { value: "Barueri", label: "Barueri" },
      { value: "Caieiras", label: "Caieiras" },
      { value: "Carapicuíba", label: "Carapicuíba" },
      { value: "Cotia", label: "Cotia" },
      { value: "Diadema", label: "Diadema" },
      { value: "Embu das Artes", label: "Embu das Artes" },
      { value: "Embú Guaçu", label: "Embú Guaçu" },
      { value: "Ferraz de Vasconcelos", label: "Ferraz de Vasconcelos" },
      { value: "Francisco Morato", label: "Francisco Morato" },
      { value: "Franco da Rocha", label: "Franco da Rocha" },
      { value: "Guararema", label: "Guararema" },
      { value: "Guarulhos", label: "Guarulhos" },
      { value: "Itapecerica da Serra", label: "Itapecerica da Serra" },
      { value: "Itapevi", label: "Itapevi" },
      { value: "Itaquaquecetuba", label: "Itaquaquecetuba" },
      { value: "Jandira", label: "Jandira" },
      { value: "Mairiporã", label: "Mairiporã" },
      { value: "Mauá", label: "Mauá" },
      { value: "Mogi das Cruzes", label: "Mogi das Cruzes" },
      { value: "Osasco", label: "Osasco" },
      { value: "Poá", label: "Poá" },
      { value: "Ribeirão Pires", label: "Ribeirão Pires" },
      { value: "Rio Grande da Serra", label: "Rio Grande da Serra" },
      { value: "Santa Isabel", label: "Santa Isabel" },
      { value: "Santana de Parnaíba", label: "Santana de Parnaíba" },
      { value: "Santo André", label: "Santo André" },
      { value: "São Bernardo do Campo", label: "São Bernardo do Campo" },
      { value: "São Caetano do Sul", label: "São Caetano do Sul" },
      { value: "Suzano", label: "Suzano" },
      { value: "Taboão da Serra", label: "Taboão da Serra" },
      { value: "Vargem Grande Paulista", label: "Vargem Grande Paulista" },
    ],
  },
  {
    label: "Franca",
    options: [
      { value: "Altinópolis", label: "Altinópolis" },
      { value: "Batatais", label: "Batatais" },
      { value: "Franca", label: "Franca" },
      { value: "Guaíra", label: "Guaíra" },
      { value: "Guará", label: "Guará" },
      { value: "Igarapava", label: "Igarapava" },
      { value: "Ipuã", label: "Ipuã" },
      { value: "Ituverava", label: "Ituverava" },
      { value: "Miguelópolis", label: "Miguelópolis" },
      { value: "Morro Agudo", label: "Morro Agudo" },
      { value: "Nuporanga", label: "Nuporanga" },
      { value: "Orlândia", label: "Orlândia" },
      { value: "Patrocínio Paulista", label: "Patrocínio Paulista" },
      { value: "Pedregulho", label: "Pedregulho" },
      { value: "São Joaquim da Barra", label: "São Joaquim da Barra" },
    ],
  },
  {
    label: "Capital - Entrância Final",
    options: [
      { value: "Acidente do Trabalho", label: "Acidente do Trabalho" },
      { value: "Butantã", label: "Butantã" },
      { value: "Cargos Numerados", label: "Cargos Numerados" },
      { value: "Consumidor", label: "Consumidor" },
      { value: "Direitos Humanos", label: "Direitos Humanos" },
      {
        value: "Enfrentamento à Violência",
        label: "Enfrentamento à Violência",
      },
      { value: "Execuções Criminais", label: "Execuções Criminais" },
      { value: "Falências", label: "Falências" },
      { value: "Família", label: "Família" },
      { value: "Habitação e Urbanismo", label: "Habitação e Urbanismo" },
      { value: "Infância e da Juventude", label: "Infância e da Juventude" },
      { value: "Ipiranga", label: "Ipiranga" },
      { value: "Itaquera", label: "Itaquera" },
      { value: "Jabaquara", label: "Jabaquara" },
      {
        value: "Juizado Especial Criminal",
        label: "Juizado Especial Criminal",
      },
      { value: "Lapa", label: "Lapa" },
      { value: "Mandados de Segurança", label: "Mandados de Segurança" },
      { value: "Meio Ambiente", label: "Meio Ambiente" },
      { value: "Militar", label: "Militar" },
      { value: "Nossa Senhora do Ó", label: "Nossa Senhora do Ó" },
      { value: "Parelheiros", label: "Parelheiros" },
      {
        value: "Patrimônio Público e Probidade",
        label: "Patrimônio Público e Probidade",
      },
      { value: "Penha de França", label: "Penha de França" },
      { value: "Perus", label: "Perus" },
      { value: "Pinheiros", label: "Pinheiros" },
      {
        value: "Promotoria de Justiça Cível",
        label: "Promotoria de Justiça Cível",
      },
      {
        value: "Promotoria de Justiça Criminal",
        label: "Promotoria de Justiça Criminal",
      },
      { value: "Registros Públicos", label: "Registros Públicos" },
      {
        value: "Repressão à Sonegação Fiscal",
        label: "Repressão à Sonegação Fiscal",
      },
      { value: "Santana", label: "Santana" },
      { value: "Santo Amaro", label: "Santo Amaro" },
      { value: "São Miguel Paulista", label: "São Miguel Paulista" },
      { value: "Tatuapé", label: "Tatuapé" },
      { value: "Unidades Prisionais", label: "Unidades Prisionais" },
      { value: "Vila Prudente", label: "Vila Prudente" },
      { value: "I Tribunal do Júri", label: "I Tribunal do Júri" },
      { value: "II Tribunal do Júri", label: "II Tribunal do Júri" },
      { value: "III Tribunal do Júri", label: "III Tribunal do Júri" },
      { value: "IV Tribunal do Júri", label: "IV Tribunal do Júri" },
      { value: "V Tribunal do Júri", label: "V Tribunal do Júri" },
    ],
  },
  {
    label: "Campinas",
    options: [
      { value: "Aguaí", label: "Aguaí" },
      { value: "Águas de Lindóia", label: "Águas de Lindóia" },
      { value: "Amparo", label: "Amparo" },
      { value: "Artur Nogueira", label: "Artur Nogueira" },
      { value: "Atibaia", label: "Atibaia" },
      { value: "Bragança Paulista", label: "Bragança Paulista" },
      { value: "Cajamar", label: "Cajamar" },
      { value: "Campinas", label: "Campinas" },
      { value: "Campo Limpo Paulista", label: "Campo Limpo Paulista" },
      { value: "Conchal", label: "Conchal" },
      { value: "Cosmópolis", label: "Cosmópolis" },
      { value: "Espírito Santo do Pinhal", label: "Espírito Santo do Pinhal" },
      { value: "Hortolândia", label: "Hortolândia" },
      { value: "Indaiatuba", label: "Indaiatuba" },
      { value: "Itapira", label: "Itapira" },
      { value: "Itatiba", label: "Itatiba" },
      { value: "Itupeva", label: "Itupeva" },
      { value: "Jaguariuna", label: "Jaguariuna" },
      { value: "Jarinu", label: "Jarinu" },
      { value: "Jundiaí", label: "Jundiaí" },
      { value: "Louveira", label: "Louveira" },
      { value: "Mogi Guaçu", label: "Mogi Guaçu" },
      { value: "Mogi Mirim", label: "Mogi Mirim" },
      { value: "Monte-Mor", label: "Monte-Mor" },
      { value: "Nazaré Paulista", label: "Nazaré Paulista" },
      { value: "Nova Odessa", label: "Nova Odessa" },
      { value: "Paulínia", label: "Paulínia" },
      { value: "Pedreira", label: "Pedreira" },
      { value: "Pinhalzinho", label: "Pinhalzinho" },
      { value: "Piracaia", label: "Piracaia" },
      { value: "São João da Boa Vista", label: "São João da Boa Vista" },
      { value: "Serra Negra", label: "Serra Negra" },
      { value: "Socorro", label: "Socorro" },
      { value: "Sumaré", label: "Sumaré" },
      { value: "Valinhos", label: "Valinhos" },
      { value: "Vargem Grande do Sul", label: "Vargem Grande do Sul" },
      { value: "Várzea Paulista", label: "Várzea Paulista" },
      { value: "Vila Mimosa", label: "Vila Mimosa" },
      { value: "Vinhedo", label: "Vinhedo" },
    ],
  },
  {
    label: "Bauru",
    options: [
      { value: "Agudos", label: "Agudos" },
      { value: "Álvaro Carvalho", label: "Álvaro Carvalho" },
      { value: "Avaí", label: "Avaí" },
      { value: "Avaré", label: "Avaré" },
      { value: "Balbinos", label: "Balbinos" },
      { value: "Bariri", label: "Bariri" },
      { value: "Barra Bonita", label: "Barra Bonita" },
      { value: "Bauru", label: "Bauru" },
      { value: "Borborema", label: "Borborema" },
      { value: "Botucatu", label: "Botucatu" },
      { value: "Cerqueira Cesar", label: "Cerqueira Cesar" },
      { value: "Chavantes", label: "Chavantes" },
      { value: "Dois Córregos", label: "Dois Córregos" },
      { value: "Duartina", label: "Duartina" },
      { value: "Fartura", label: "Fartura" },
      { value: "Gália", label: "Gália" },
      { value: "Garça", label: "Garça" },
      { value: "Iacanga", label: "Iacanga" },
      { value: "Iaras", label: "Iaras" },
      { value: "Ibitinga", label: "Ibitinga" },
      { value: "Ipaussu", label: "Ipaussu" },
      { value: "Itápolis", label: "Itápolis" },
      { value: "Itatinga", label: "Itatinga" },
      { value: "Jaú", label: "Jaú" },
      { value: "Lençois Paulista", label: "Lençois Paulista" },
      { value: "Macatuba", label: "Macatuba" },
      { value: "Marília", label: "Marília" },
      { value: "Ourinhos", label: "Ourinhos" },
      { value: "Palmital", label: "Palmital" },
      { value: "Pederneiras", label: "Pederneiras" },
      { value: "Piraju", label: "Piraju" },
      { value: "Pirajuí", label: "Pirajuí" },
      { value: "Piratininga", label: "Piratininga" },
      { value: "Pompéia", label: "Pompéia" },
      { value: "Reginópolis", label: "Reginópolis" },
      { value: "Santa Cruz do Rio Pardo", label: "Santa Cruz do Rio Pardo" },
      { value: "São Manuel", label: "São Manuel" },
    ],
  },
  {
    label: "Araçatuba",
    options: [
      { value: "Andradina", label: "Andradina" },
      { value: "Araçatuba", label: "Araçatuba" },
      { value: "Avanhandava", label: "Avanhandava" },
      { value: "Bilac", label: "Bilac" },
      { value: "Birigui", label: "Birigui" },
      { value: "Buritama", label: "Buritama" },
      { value: "Cafelândia", label: "Cafelândia" },
      { value: "Getulina", label: "Getulina" },
      { value: "Guararapes", label: "Guararapes" },
      { value: "Ilha Solteira", label: "Ilha Solteira" },
      { value: "Lavínia", label: "Lavínia" },
      { value: "Lins", label: "Lins" },
      { value: "Mirandópolis", label: "Mirandópolis" },
      { value: "Penápolis", label: "Penápolis" },
      { value: "Pereira Barreto", label: "Pereira Barreto" },
      { value: "Promissão", label: "Promissão" },
      { value: "Valparaíso", label: "Valparaíso" },
    ],
  },
];

// ─────────────────────────────────────────────
//  CLASSIFICADOS
// ─────────────────────────────────────────────

export const negotiationTypeOptions = [
  { label: "Venda", value: "1" },
  { label: "Aluguel", value: "2" },
  { label: "Temporada", value: "3" },
];

export const itemConditionOptions = [
  { label: "Novo", value: "1" },
  { label: "Usado", value: "2" },
];

export const tradeAcceptanceOptions = [
  { label: "Aceita proposta por troca", value: "1" },
  { label: "Não aceita troca", value: "2" },
];

export const targetAudienceOptions = [
  { label: "Para público em geral", value: "1" },
  { label: "Apenas para associados", value: "2" },
];

export const saleTypeOptions = [
  { label: "Venda", value: "1" },
  { label: "Aluguel", value: "2" },
  { label: "Temporada", value: "3" },
];

export const tradeOptions = [
  { label: "Aceita proposta por troca", value: "1" },
  { label: "Não aceita troca", value: "2" },
];

export const membersOnlyOptions = [
  { label: "Para público em geral", value: "1" },
  { label: "Apenas para associados", value: "2" },
];
